var map = {
	"./en/infoCollectAgree.ts": [
		6766,
		814
	],
	"./zh_CN/infoCollectAgree.ts": [
		4029,
		29
	],
	"./zh_HK/infoCollectAgree.ts": [
		8260,
		260
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3482;
module.exports = webpackAsyncContext;